<template lang="pug">
  .column
    .row.preference-header.middle
      router-link(:to='{name: routes.preferences}')
        simple-svg.m-right-2(:filepath='arrowLeftIcon' width='20px' height='20px')
      h1.title-medium.bold.black {{ $t('preferences.languages.languageConfiguration') }}
    .preference-body
      .row.middle.m-bottom-2
        simple-svg.m-right-2(:filepath='worldIcon' width='20px' height='20px')
        h2.title-small.bold {{ $t('preferences.languages.defaultNavigationLanguage') }}
      p.text-normal.dark-gray.m-bottom-1 {{ $t('preferences.languages.defaultNavigationLanguageDescription') }}
      languages-k-select.m-bottom-4(
        v-if='languageConfiguration'
        name='defaultNavigationLanguage'
        withBorder
        :options='languagesOptions'
        :preselectedOption='navigationLanguage'
        :placeholder='$t("krea.newResource.introductoryContent.chooseLanguagePlaceholder")'
        @selectOption='onSelectedLanguage'
        :error='showErrors && !navigationLanguage'
        :errorMessage='$t("preferences.languages.languageRequiredError")'
      )
      .row.middle.m-bottom-2
        simple-svg.m-right-2(:filepath='worldIcon' width='20px' height='20px')
        h2.title-small.bold {{ $t('preferences.languages.defaultMailingLanguage') }}
      p.text-normal.dark-gray.m-bottom-1 {{ $t('preferences.languages.defaultMailingLanguageDescription') }}
      languages-k-select.m-bottom-4(
        v-if='languageConfiguration'
        name='defaultMailingLanguage'
        withBorder
        :options='languagesOptions'
        :preselectedOption='mailingLanguage'
        :placeholder='$t("krea.newResource.introductoryContent.chooseLanguagePlaceholder")'
        @selectOption='onSelectedLanguage'
        :error='showErrors && !mailingLanguage'
        :errorMessage='$t("preferences.languages.languageRequiredError")'
      )
      button.m-left-auto.primary-button(@click='submit') {{  $t('preferences.languages.save') }}
</template>

<script>
import arrowLeftIcon from '@/assets/ic_chevron-left.svg'
import worldIcon from '@/assets/ic_world.svg'
import { routes } from '../../router'
import { mapLanguageOptions, supportedLanguages } from '../../constants/languages'
import LanguagesKSelect from '@/components/LanguagesKSelect'
import { mapActions, mapState } from 'vuex'

export default {
  components: { LanguagesKSelect },
  data() {
    return {
      routes,
      arrowLeftIcon,
      worldIcon,
      showErrors: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo.userInfo,
      languageConfiguration: state => state.userInfo.userInfo.languageConfiguration
    }),
    languagesOptions() {
      return supportedLanguages.map(mapLanguageOptions)
    },
    navigationLanguage() {
      return this.userInfo.languageConfiguration.defaultNavigationLanguage
    },
    mailingLanguage() {
      return this.userInfo.languageConfiguration.defaultMailingLanguage
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'setLanguageConfiguration',
      'editConfigurationLanguage'
    ]),
    onSelectedLanguage(field, value) {
      this.editConfigurationLanguage({ field, value })
    },
    async submit() {
      this.showErrors = false
      if (!this.mailingLanguage || !this.navigationLanguage) {
        this.showErrors = true
        return
      }
      this.showElement({ element: 'fullPageLoader' })
      await this.setLanguageConfiguration({
        mailingLanguage: this.mailingLanguage,
        navigationLanguage: this.navigationLanguage
      })
      this.hideElement({ element: 'fullPageLoader' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/_colors.scss';

.preference-header{
  padding: 0 30px;
  height: 70px;
  border-bottom: 2px solid $light-gray;
}

.preference-body{
  padding: 30px;
}
</style>
